export const UPDATE_LOAN_PAYMENT = "UPDATE_LOAN_PAYMENT";
export const UPDATE_LOAN_MORATORIUM_PAYMENT = "UPDATE_LOAN_MORATORIUM_PAYMENT";
export const UPDATE_LOAN_DUES_WAIVER = "UPDATE_LOAN_DUES_WAIVER";
export const UPDATE_LOAN_SETTLEMENT = "UPDATE_LOAN_SETTLEMENT";
export const UPDATE_LOAN_SETTLEMENT_PAYMENT = "UPDATE_LOAN_SETTLEMENT_PAYMENT";
